import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { BlogDetailsViewV2 } from 'views/rebranded-module/blogs-module/BlogDetailsViewV2';
import { HydrationWrapper } from 'views/common/components';
import { handleBlogPageSSR } from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/utils/handleBlogPageSSR';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { useBlogsDetailsCMSData } from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/hooks/useBlogsDetailsCMSData';

const BlogPage = (props) => {
  const { serverData } = props;
  const content = useBlogsDetailsCMSData();

  return (
    <HydrationWrapper>
      <ContentContext.Provider value={content?.data}>
        <BlogDetailsViewV2 serverData={serverData} />
      </ContentContext.Provider>
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const { locale, query, res } = ctx;

  if (query.force_old_page_load == 1) {
    res.statusCode = 503;
    return { props: {} };
  }

  const serverData = await handleBlogPageSSR(ctx);

  if (serverData.redirectURL) {
    return {
      redirect: {
        destination: serverData.redirectURL,
        permanent: true,
      },
    };
  }
  if (serverData.serverError) {
    res.statusCode = 404;
  }

  const hreflangData = generateHreflang(
    PATHS.motorcycleTouring.slug(query?.slug).url,
    locale,
  );

  const pageOptions = {
    rebrandingPage: true,
    options: {
      transparentNavBar: true,
    },
  };

  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'blog_details_page',
        'common_share',
      ])),
      hreflangData,
      ...serverData,
      ...pageOptions,
    },
  };
}
export default BlogPage;
